import { Reveal, RevealLines } from "./Reveal";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { BRAND } from "../../lib/brand";

export default function Programme() {
  return (
    <section
      id="programme"
      className="relative bg-cream py-24 md:py-40 overflow-hidden"
      data-testid="programme-section"
    >
      <div className="relative mx-auto max-w-[1500px] px-6 md:px-10">
        {/* Chapter tag */}
        <div className="mb-10 md:mb-14">
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="chapter-number text-3xl md:text-4xl">04</span>
              <span className="text-[11px] uppercase tracking-[0.3em] text-olive/60">
                Programmes d'accompagnement
              </span>
            </div>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          {/* Left: title */}
          <div className="md:col-span-7">
            <RevealLines
              lines={["Inscrire le soin", "dans la"]}
              className="font-serif text-olive text-5xl md:text-7xl lg:text-[7rem] leading-[0.95] tracking-tighter"
            />
            <RevealLines
              lines={["durée."]}
              delayBase={0.25}
              className="font-serif italic text-gold text-5xl md:text-7xl lg:text-[7rem] leading-[0.95] tracking-tighter"
            />
          </div>

          {/* Right: text + Instagram CTA */}
          <div className="md:col-span-5 md:pt-4">
            <Reveal delay={0.3}>
              <p className="text-olive/80 text-[17px] leading-[1.75] font-light">
                Parce que le corps apprécie la régularité, les programmes
                d'accompagnement permettent d'inscrire les bienfaits des soins
                dans la durée.
              </p>
            </Reveal>
            <Reveal delay={0.45}>
              <p className="mt-6 text-olive/75 text-[16px] leading-[1.7] font-light">
                Corps &amp; Sens propose également des cures de{" "}
                <span className="text-gold italic">5 à 10 séances</span> pour
                chacun des soins.
              </p>
            </Reveal>

            {/* Instagram CTA */}
            <Reveal delay={0.6}>
              <motion.a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="programme-instagram-cta"
                whileHover={{ y: -2 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="group mt-12 relative flex items-center gap-6 border-t border-olive/20 pt-8 pr-4"
              >
                <div className="relative h-14 w-14 md:h-16 md:w-16 shrink-0 rounded-full border border-gold/50 grid place-items-center text-gold overflow-hidden transition-all duration-700 group-hover:bg-gold group-hover:border-gold group-hover:text-cream">
                  <Instagram
                    className="h-5 w-5 md:h-6 md:w-6 relative z-10"
                    strokeWidth={1.4}
                  />
                  <motion.span
                    className="absolute inset-0 rounded-full"
                    animate={{
                      boxShadow: [
                        "0 0 0 0 rgba(184,148,79,0.45)",
                        "0 0 0 14px rgba(184,148,79,0)",
                      ],
                    }}
                    transition={{ duration: 2.4, repeat: Infinity, ease: "easeOut" }}
                  />
                </div>
                <div className="flex-1">
                  <p className="text-[11px] uppercase tracking-[0.3em] text-olive/55">
                    Instagram
                  </p>
                  <p className="mt-1.5 font-serif text-xl md:text-2xl text-olive tracking-tight leading-tight group-hover:text-gold transition-colors duration-500">
                    Pour plus d'information,
                    <br className="hidden md:block" />{" "}
                    <span className="italic">retrouvez-nous</span> sur Insta
                  </p>
                  <p className="mt-1 text-olive/55 text-[13px] font-light italic">
                    @corpsetsens
                  </p>
                </div>
              </motion.a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
